import React, { act, useEffect, useState } from 'react'
import Header from '../../../component/Produzioni/Header'
import DashboardCard from '../../../component/Produzioni/DashboardCard';
import TableInputFeild from '../../../component/Produzioni/TableInputFeild';
import TrattamentiFrom from '../../../component/Produzioni/TrattamentiFrom';
import { resetFormData, resetFormSubmit, storeFormData } from '../../../features/produzioniFormData/produzioniFormDataSlice';
import produzioniFormAPI from '../../../services/produzioniFormApi';
import { useDispatch, useSelector } from 'react-redux';

const RaccoltaUva = ({ option, activeStep, setActiveStep }) => {

  const dispatch = useDispatch();
  const singleProduzioneID = useSelector((state) => state.produzioni.singleProduzioneId);
  const submitForm = useSelector((state) => state.produzioniForm.submitForm);

  const [tableData, setTableData] = useState([
    {company_id: Number(localStorage.getItem('company_id')) || "", step: activeStep, prod_id: singleProduzioneID, metto_di_raccolta: "", qty: "", uva_scartata: "", room_temperature: "", prodotto_id: "" }
  ]);

  const [treatment, setTreatment] = useState([
    { company_id: Number(localStorage.getItem('company_id')) || "", step: activeStep, prod_id: singleProduzioneID, pro_treatment_id: "", tratt_date: null, pro_utilizzato: "", pro_qty: "", mod_di_applicazione: "", operatore_id: "", sicurezza: "" }
  ]);

  const data = {
    id: 1,
    title: "Raccolta Uva",
    description:
      "Organizza la raccolta assicurando che l'uva venga selezionata con cura per preservare la qualità del vino.",
    buttonText: "Completa fase",
  };

  const totalCollected = tableData.reduce((acc, item) => acc + Number(item.qty), 0);
  const discardedGrapes = tableData.reduce((acc, item) => acc + Number(item.uva_scartata), 0);

  const dummyData = {
    totalCollected: totalCollected + " Kg",
    discardedGrapes: discardedGrapes + " Kg",
    discardPercentage: totalCollected > 0 
    ? ((discardedGrapes / totalCollected) * 100).toFixed(2) + "%" 
    : "0%",
    temperatureCompliance: "OK",
    tasks: [
      "Determinazione della data ottimale di raccolta",
      "Verifica delle condizioni meteorologiche",
      "Analisi del grado di maturazione dell'uva",
      "Assegnazione dei lotti di raccolta"
    ],
  };

  const infoFields = [
    { label: "Q.ta Totale raccolta", key: dummyData.totalCollected },
    { label: "Uva scarta", key: dummyData.discardedGrapes },
    { label: "% Uva scarta", key: dummyData.discardPercentage, showIcon: true },
    { label: "Conformità Temperatura", key: dummyData.temperatureCompliance, showIcon: true },
  ];

  const fetchDataForUpdate = async () => {
    try {
      const payload = {
        company_id: localStorage.getItem('company_id'),
        step: activeStep,
        prod_id: singleProduzioneID,
      };

      const response = await produzioniFormAPI.getSingleStepFormData(payload);
      console.log(response, "response racolta")
      if (response?.data.data.raccoltauva?.length) {
        const existingTable = response.data.data.raccoltauva;
        setTableData(existingTable);
      }
      if (response?.data.data.production_step_treatment?.length) {
        const existingTreatment = response.data.data.production_step_treatment;
        setTreatment(existingTreatment);
      }
    } catch (error) {
      console.error("Error fetching single step form data:", error);
    }
  };
  
  useEffect(() => {
      fetchDataForUpdate();
  }, []);

  const onSubmit = async (tableData, treatment) => {
    const data = {
      step: activeStep,
      forms: {
        raccoltauva: tableData,
        production_step_treatment: treatment
      }
    }
    try {
        await produzioniFormAPI.updateStepFormData(singleProduzioneID, data);
    
      setActiveStep((prev) => prev + 1);
    } catch (error) {
      fetchDataForUpdate();
      console.error('Error submitting form data:', error);
    }
  };

  useEffect(() => {
    if (submitForm) {
      onSubmit(tableData, treatment);
      dispatch(resetFormSubmit());
    }
  }, [submitForm, dispatch]);

  return (
    <>
      <Header data={data} setActiveStep={setActiveStep} activeStep={activeStep} />
      <DashboardCard dummyData={dummyData} infoFields={infoFields} />
      <TableInputFeild
        option={option}
        rows={tableData}
        setRows={setTableData}
        activeStep={activeStep}
      />
      <TrattamentiFrom
        option={option}
        rows={treatment}
        setRows={setTreatment}
        activeStep={activeStep}
      />
    </>
  )
}

export default RaccoltaUva